import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ConfirmationModal } from "@mwi/ui";
import usePrompt from "./../../../hooks/usePrompt";

type UnsavedChangesPromptProps = {
  isDirty: boolean;
  children: any;
};

const UnsavedChangesPrompt = ({
  isDirty,
  children,
}: UnsavedChangesPromptProps): JSX.Element => {
  const navigate = useNavigate();

  const [isPop, setIsPop] = useState<boolean>(false);
  const [shouldGuard, setShouldGuard] = useState(true);
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [destination, setDestination] = useState<string | undefined>(undefined);

  usePrompt((location, action) => {
    setDestination(location.pathname);
    setIsPop(action === "POP");
    return !shouldGuard;
  }, isDirty && !shouldNavigate);

  useEffect(() => {
    if (!shouldGuard) {
      isPop ? navigate(-1) : navigate(destination!);
    }
  }, [shouldGuard, navigate, destination, isPop]);

  useEffect(() => {
    if (destination) {
      setModalVisible(true);
    }
  }, [destination]);

  const onConfirm = () => {
    setModalVisible(false);
    setShouldGuard(false);
    setShouldNavigate(true);
  };

  const onClose = () => {
    setDestination(undefined);
    setModalVisible(false);
    setShouldGuard(true);
  };

  return (
    <>
      {children}
      <ConfirmationModal
        title="Are you sure?"
        description="You have unsaved changes. Are you certain you want to leave this page?"
        isOpen={modalVisible}
        onConfirm={onConfirm}
        onClose={onClose}
      />
    </>
  );
};

export default UnsavedChangesPrompt;
